import { render, staticRenderFns } from "./AbkSurveyForm.vue?vue&type=template&id=74bacd2c&scoped=true&"
import script from "./AbkSurveyForm.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyForm.vue?vue&type=style&index=0&id=74bacd2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bacd2c",
  null
  
)

export default component.exports